import request from '@/core/request';
import apiRoute from '@/config/apiRoute';
import auth from '@/core/auth';

const state = {
	token: auth.getToken(),
	info: '',
}

const mutations = {
	SET_TOKEN: (state, token) => {
		state.token = token
	},
	SET_USER_INFO: (state, info) => {
		state.info = info;
	}
}

const actions = {
	login({ commit }, params) {
		const url = apiRoute.login;
		return new Promise((resolve, reject) => {
			request({
				url,
				method: 'post',
				data: params
			}).then(res => {
				const { status, result } = res;

				if (status == 0) {
					commit('SET_TOKEN', result.token)
					auth.setToken(result.token)
				}

				resolve(res);
			}).catch(error => {
				reject(error);
			});
		});
	},
	getInfo({ commit }) {
		const url = apiRoute.getUserInfo;
		const token = state.token;
		return new Promise((resolve, reject) => {
			request({
				url: url,
				method: 'post',
				token: true,
				params: { token }
			}).then(res => {
				const { status, result } = res;

				if (status == 0) {
					commit('SET_USER_INFO', result);
				}

				resolve(result);
			}).catch(error => {
				reject(error);
			});
		});
	},
	logout({ commit, state }) {
		return new Promise((resolve, reject) => {
			const url = apiRoute.logout;
			const token = state.token;
			request({
				url: url,
				method: 'post',
				token: true,
				params: { token }
			}).then(res => {
				const { status } = res;

				if (status == 0) {
					commit('SET_TOKEN', '');
					commit('SET_USER_INFO', '');
					auth.removeToken();
					resolve();
				}

				resolve(result);
			}).catch(error => {
				reject(error);
			});
		})
	},
	resetToken({ commit }) {

		return new Promise(resolve => {
			commit('SET_TOKEN', null);
			commit('SET_USER_INFO', null);
			auth.removeToken();
			resolve()
		})

	},
	setToken({ commit }, token){
		return new Promise(resolve => {
			commit('SET_TOKEN', token)
			auth.setToken(token)
			resolve()
		})
	},
	reg({ commit }, params) {
		const url = apiRoute.reg;
		return new Promise((resolve, reject) => {
			request({
				url,
				method: 'post',
				data: params
			}).then(res => {
				const { status, result } = res;

				if (status == 0) {
					commit('SET_TOKEN', result.token)
					auth.setToken(result.token)
				}

				resolve(res);
			}).catch(error => {
				reject(error);
			});
		});
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js